import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import Footer from '~/components/Footer';
import Menu from '~/components/Menu';
import api from '~/services/api';
import { addMenuID } from '~/store/modules/Modulos/actions';
import { Container } from '~/styles/pagesStyle';
import Lista from './Lista';

function SubMenuEspec() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [menuName, setMenuName] = useState('');
  const dispatch = useDispatch();

  useEffect(() => {
    setLoading(true);
    dispatch(addMenuID(id));
    async function getMenuName() {
      await api.get(`Menu/${id}`).then((response) => {
        setMenuName(response.data.nome);
        setLoading(false);
      });
    }
    getMenuName();
  }, [id]);

  return (
    <Container>
      <Footer />
      <Menu />
      {loading ? (
        <Spinner
          style={{ width: '3rem', height: '3rem', margin: '20% 45% 0 0' }}
        />
      ) : (
        <Lista setLoading={setLoading} menuName={menuName} />
      )}
    </Container>
  );
}

export default SubMenuEspec;
